import React from 'react'
import { type CertificateTile } from '@mc/api'
import { Button, IconChevronLeftDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Link from 'components/Link'
import { TrackClick } from 'pages/certificates/tracking'

interface CertificatesSectionProps {
  tiles: CertificateTile[]
  isError: boolean
  isLoading: boolean
  onClose: () => void
  onHideCertificatesSection: () => void
}

export const CertificatesSection = ({
  tiles,
  isError,
  isLoading,
  onClose,
  onHideCertificatesSection,
}: CertificatesSectionProps) => {
  const { t } = useTranslation('@mc/next')
  const { t: tc } = useTranslation('@mc/certificates')

  const showList = !isError && !(isLoading && tiles.length === 0)

  return (
    <div className='mc-px-4'>
      <Button
        className='mc-p-3 mc-my-5'
        onClick={onHideCertificatesSection}
        kind='tertiary'
        symmetrical
      >
        <IconChevronLeftDefault size='sm' srText={t('nav.cta.back')} />
      </Button>
      {showList && (
        <div className='mc-corners--md mc-p-4 mc-bg-container-tint-medium'>
          <ul>
            {tiles
              // Only tiles the server gives a cta have a live detail page (same
              // signal CertificateCard uses on the hub); without it the link 404s.
              .filter((tile) => tile.slug && tile.cta)
              .map((tile) => (
                <li key={`certificate-link-${tile.slug}`} className='mc-mb-4'>
                  <TrackClick
                    event='certificateNavigationClicked'
                    level='quaternary'
                  >
                    <Link href={paths.certificate(tile.slug)} onClick={onClose}>
                      {tile.title}
                    </Link>
                  </TrackClick>
                </li>
              ))}
            <li>
              <TrackClick
                event='certificateNavigationClicked'
                level='quaternary'
              >
                <Link href={paths.certificates} onClick={onClose}>
                  {tc('certificatesMenuMobile.viewAllCertificates')}
                </Link>
              </TrackClick>
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}
